import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import type { Lead } from '@/shared/types';
import { Button } from '@/shared/ui/button';
import { Label } from '@/shared/ui/label';
import { Textarea } from '@/shared/ui/textarea';
import { saveLeadObservation } from '../api/use-leads';

interface LeadObservationsPanelProps {
  idPassbook: string;
  lead: Lead;
  onObservacaoSaved: (observacao: string) => void;
}

export function LeadObservationsPanel({ idPassbook, lead, onObservacaoSaved }: LeadObservationsPanelProps) {
  const [observacao, setObservacao] = useState(lead.observacao ?? '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setObservacao(lead.observacao ?? '');
  }, [lead.observacao, lead._id]);

  const handleSave = async () => {
    if (!lead._id) {
      toast.error('Lead inválido.');
      return;
    }
    setSaving(true);
    try {
      await saveLeadObservation(idPassbook, lead._id, observacao);
      onObservacaoSaved(observacao);
      toast.success('Observação salva.');
    } catch {
      toast.error('Falha ao salvar observação.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="lead-observacao">Observação/Comentários (Informação Interna)</Label>
      <Textarea
        id="lead-observacao"
        value={observacao}
        onChange={(e) => setObservacao(e.target.value)}
        placeholder="Escreva algo sobre o cliente."
        rows={10}
        className="min-h-[200px] resize-y"
      />
      <div className="flex justify-end">
        <Button type="button" onClick={handleSave} loading={saving} size="sm">
          Salvar
        </Button>
      </div>
    </div>
  );
}
